<script setup lang="ts">
import { computed } from 'vue'
import { useMessagePreview } from '#entities/message'
import type { AlertReply } from '../model/alert'
import AlertContentLayout from './alert-content-layout.vue'

const { alert } = defineProps<{ alert: AlertReply }>()

const emit = defineEmits<{ 'link-click': [] }>()

const message = computed(() => alert.message)
const messagePreview = useMessagePreview(message, 'small')

const reply = computed(() => alert.reply)
const replyPreview = useMessagePreview(reply, 'large')
</script>

<template>
  <AlertContentLayout :alert="alert" @link-click="emit('link-click')">
    <template #label>sent reply to your message "{{ messagePreview }}":</template>

    <template #content>
      {{ replyPreview }}
    </template>
  </AlertContentLayout>
</template>
